import { ApolloQueryResult, useQuery } from '@apollo/client';

import { isDemoEnvironment } from '../../../../../constants/global';
import { handleGql403 } from '../../../../../utils';
import { GetAllAdAccountsByOrgIdQuery, GetAllAdAccountsByOrgIdQueryVariables } from '../../../types';
import { MockedAdAccountsByUser } from '../../../user/useFetchAdAccountByUser/mock';
import { GET_AD_ACCOUNTS_BY_ORG_ID } from './adAccountByOrgId';

export type AdAccountByOrgIdData = Array<GetAllAdAccountsByOrgIdQuery['getAllAdAccountsByOrgId']['edges'][0]['node']>;

export type UseGetAdAccountsByOrgId = {
  data: AdAccountByOrgIdData;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<GetAllAdAccountsByOrgIdQuery>>;
};

const useGetAdAccountsByOrgId = (orgId: string, isGhostMode = false): UseGetAdAccountsByOrgId => {
  const { data, loading, refetch } = useQuery<GetAllAdAccountsByOrgIdQuery, GetAllAdAccountsByOrgIdQueryVariables>(
    GET_AD_ACCOUNTS_BY_ORG_ID,
    {
      notifyOnNetworkStatusChange: true,
      skip: isDemoEnvironment || (!orgId && !isGhostMode),
      onError: handleGql403,
      variables: {
        organizationId: orgId,
        paginationOptions: {
          limit: 500,
          offset: 0,
        },
      },
    }
  );

  const edges: AdAccountByOrgIdData = data?.getAllAdAccountsByOrgId?.edges?.map((edge) => edge?.node) || [];
  const mockedData = [{ ...MockedAdAccountsByUser.adAccountsByUser.edges[0].node, accountsApprovedForTerms: true }];

  return {
    data: isDemoEnvironment ? (mockedData as AdAccountByOrgIdData) : edges,
    loading,
    refetch,
  };
};

export default useGetAdAccountsByOrgId;
